export default __webpack_public_path__ + "static/media/reaction-diffusion.61c49bf0.png";